module.exports = __webpack_public_path__ + "assets/images/Order_Type_I_Icon.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/Order_Type_I_Icon.png
// module id = 1424
// module chunks = 1